module.exports = "/lucky-balls/img/weager/balls/normal/LB_5.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_5.png
// module id = 1188
// module chunks = 0